import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const test =""


const StratfordCompleted = ({language}) =>{

    if(language == 'FR'){
        return (
            <div>
            <p>Merci beaucoup de nous avoir transmis vos commentaires dans le cadre de ce sondage. Pour en savoir plus sur les prochaines étapes, veuillez consulter la page sur l’engagement du personnel dans CORE : <a href="https://www.cfmws-sbmfc.com/sites/intranet-cfmws/human-resources/SitePageModern/76580/employee-engagement">Ressources Humaines - Sondage sur l’engagement du personnel</a>
            </p>
            </div>
        )
    }

    return (
        <div>
                <p>Thank you for completing the survey, your honest feedback is greatly appreciated. For next steps, 
                    please visit the dedicated Employee Engagement CORE page: <a href="https://www.cfmws-sbmfc.com/sites/intranet-cfmws/human-resources/SitePageModern/76580/employee-engagement">Human Resources - Employee Engagement Survey</a>
                </p>
            </div>
    )
}

export default StratfordCompleted;